import React, {
  useState,
  useEffect,
} from "react";
import _ from "lodash";
import { showSpinner, closeSpinner, alert } from "../../../js/modules/Dialogs";
import { sessionExpired } from "../../../config/messages";
import { toScreen } from "../../../js/modules/Routing";
import PropTypes from "prop-types";
import withNavigate from "../withNavigate";
import TopNav from "../../commonUI/TopHeader/TopHeader";
import Box from "@mui/material/Box";
import RefundDetails from "./RefundDetails";
import DriverPenalty from "./DriverPenalty";
import {
  getretrieveDriverPenaltiesIssueResolutions,
  getretrieveRefundIssueResolutions,
  getretrieveDriverPayIssueResolutions,
  getIssueResolutionsCount,
} from "../../../services/issueService";
import moment from "moment-timezone";
import { getConversation } from "../../../services/messageService";
import FlaggedImages from "./FlaggedImages";
import RefundsTab from "./RefundsTab";
import DriverPenaltiesTab from "./DriverPenaltiesTab";
import DriverPayEligibilityTab from "./DriverPayEligibilityTab";
import FlaggedMessagesTab from "./FlaggedMessagesTab";
import { MOCK_FLAGGED_IMAGES } from "../../../config/constants";
import { toast } from "react-toastify";
import DriverPayEligibility from "./DriverPayEligibility";

const IssuesResolution = ({ userDetails, navigate }) => {
  const [state, setState] = React.useState({
    right: false,
  });
  const [currentView, setCurrentView] = useState(null);
  const [selectedIssueResolution, setSelectedIssueResolution] = useState(null);
  const [count, setCount] = useState(0);

  // Date filters
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [cancelledStartDate, setCancelledStartDate] = useState(null);
  const [cancelledEndDate, setCancelledEndDate] = useState(null);
  const [scheduledStartDate, setScheduledStartDate] = useState(null);
  const [scheduledEndDate, setScheduledEndDate] = useState(null);
  const [flaggedByAISubmittedStartDate, setFlaggeByAISubmittedStartDate] =
    useState(null);
  const [flaggedByAISubmittedEndDate, setFlaggeByAISubmittedEndDate] =
    useState(null);

  // Search and filters
  const [searchValue, setSearchValue] = useState("");
  const [search, setSearch] = useState("");
  const [jobTypeFilter, setJobTypeFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("allStatus");
  const [eligibilityFilter, setEligibilityFilter] = useState("all");
  const [flaggedByAIStatusFilter, setFlaggedByAIStatusFilter] =
    useState("allStatus");
  const [filter, setFilter] = useState(
    window.history.state?.usr?.selectedFilter ?? "all"
  );

  const [pageSize, setPageSize] = useState(15);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [inputValue, setInputValue] = useState(1);
  const [sort, setSort] = useState("statusSorter=-1");
  const [activeTab, setActiveTab] = useState("refund");
  const [activeFilters, setActiveFilters] = useState({
    refund: null,
    driverPenalties: null,
  });
  const [flaggedByAI, setFlaggedByAI] = useState(null);
  const [issueResolutions, setIssueResolutions] = useState([]);
  const [filterCount, setFilterCount] = useState({
    refundsCount: 0,
    driverPenaltiesCount: 0,
    driverPayEligibilityCount: 0,
  });
  const [flaggedImages, setFlaggedImages] = useState([]);
  const [flaggedImagesStartDate, setFlaggedImagesStartDate] = useState(null);
  const [flaggedImagesEndDate, setFlaggedImagesEndDate] = useState(null);

  const [conversationDetails, setConversationDetails] = useState();


  useEffect(() => {
    fetchFilterCount();
  }, []);

  const fetchFilterCount = async () => {
    showSpinner();
    try {
      const resJson = await getIssueResolutionsCount(
        { userType: "user" }
      );

      closeSpinner();

      setFilterCount({
        refundsCount: resJson?.refundsCount,
        driverPenaltiesCount: resJson?.driverPenaltiesCount,
        driverPayEligibilityCount: resJson?.driverPayEligibilityCount,
      });
    } catch (error) {
      closeSpinner();
      if (error.response?.status === 401) {
        toast.error(sessionExpired);
        toScreen(false, navigate, "/logout");
      } else if (error.response?.status === 400) {
        alert(error.message);
      } else {
        alert("Error fetching issue count: " + error?.message);
      }
    }
  };

  const getConversations = async (convPropsArgument) => {
    if (!convPropsArgument) {
      toast.error("Unable to load conversation: Invalid data");
      return;
    }

    const requasterShortId = userDetails?.accountInfo?.shortId || userDetails?.shortId || "Admin";
    const receiverShortId = convPropsArgument?.driverDetails?.shortId || convPropsArgument?.shortId;
    const receiverId = convPropsArgument?.driverDetails?._id || convPropsArgument?._id;

    if (!receiverShortId || !receiverId) {
      toast.error("Unable to load conversation: Missing driver details");
      return;
    }

    const queryParams = {
      receiverShortId,
      receiverId,
      requasterShortId,
      page: 1,
      pageSize: 100000,
    };

    showSpinner();
    try {
      const resJson = await getConversation(queryParams);

      closeSpinner();

      setConversationDetails(resJson?.data);
    } catch (error) {
      closeSpinner();
      if (error.response?.status === 401) {
        return toast.error(error.message || "401 Unauthorized", () =>
          window.history.back()
        );
      }

      if (error.response?.status === 400) {
        console.error("Conversation API error:", error.response?.data);
        return toast.error(error.response?.data?.message || error.message || "Something went wrong!", () =>
          window.history.back()
        );
      }

      toast.error("Error fetching conversations: " + error?.message);
    }
  };

  // Toggle drawer function
  const toggleDrawer =
    (anchor, open, view = null, issueResolution = null) =>
    (event) => {
      // if (
      //   event.type === "keydown" &&
      //   (event.key === "Tab" || event.key === "Shift")
      // ) {
      //   return;
      // }

      setState({ ...state, [anchor]: open });

      if (open) {
        setCurrentView(view);
        if (issueResolution) {
          setSelectedIssueResolution(issueResolution);
        } else {
          setSelectedIssueResolution(null);
        }
        getConversations(issueResolution);
      }
    };

  useEffect(() => {
    setInputValue(page);
  }, [page]);

  useEffect(() => {
    if (activeTab === "flaggedImages") {
      setFlaggedImages(MOCK_FLAGGED_IMAGES);
      setTotalPages(1);
    }
  }, [activeTab]);

  // Enhanced search function
  const searchIssueAndResolution = () => {
    setSearch(searchValue);
    setPage(1);
  };

  // Format date for API
  const formatDateForAPI = (date) => {
    return date ? moment(date).format("YYYY-MM-DD") : null;
  };

  // Enhanced sorting function
  const sortIssueResolutions = (event, field) => {
    if (event) event.preventDefault();

    const sortFields = {
      firstnameSorter: { asc: "firstnameSorter=1", desc: "firstnameSorter=-1" },
      reasonSorter: { asc: "reasonSorter=1", desc: "reasonSorter=-1" },
      cancelledOnSorter: {
        asc: "cancelledOnSorter=1",
        desc: "cancelledOnSorter=-1",
      },
      cancellationRateSorter: {
        asc: "cancellationRateSorter=1",
        desc: "cancellationRateSorter=-1",
      },
      job: { asc: "job=1", desc: "job=-1" },
      bookedFor: { asc: "bookedFor=1", desc: "bookedFor=-1" },
      bookedOnSorter: { asc: "bookedOnSorter=1", desc: "bookedOnSorter=-1" },
      scheduledForSorter: {
        asc: "scheduledForSorter=1",
        desc: "scheduledForSorter=-1",
      },
      amountSorter: { asc: "amountSorter=1", desc: "amountSorter=-1" },
      requestedOnSorter: {
        asc: "requestedOnSorter=1",
        desc: "requestedOnSorter=-1",
      },
      statusSorter: { asc: "statusSorter=1", desc: "statusSorter=-1" },
      startDate: { asc: "startDate=1", desc: "startDate=-1" },
      uses: { asc: "uses=1", desc: "uses=-1" },
      endDate: { asc: "endDate=1", desc: "endDate=-1" },
      cancelledOnSorter: {
        asc: "cancelledOnSorter=1",
        desc: "cancelledOnSorter=-1",
      },
      postedOnSorter: {
        asc: "postedOnSorter=1",
        desc: "postedOnSorter=-1",
      },
      scheduledForSorter: {
        asc: "scheduledForSorter=1",
        desc: "scheduledForSorter=-1",
      },
    };

    const currentSort = sortFields[field];
    if (!currentSort) return;

    const newSort =
      sort === currentSort.asc ? currentSort.desc : currentSort.asc;

    setSort(newSort);
    setPage(1);
  };

  const getRefundIssueResolutions = async () => {
    const dateLowerRange = formatDateForAPI(startDate);
    const dateUpperRange = formatDateForAPI(endDate);

    if ((startDate && !endDate) || (!startDate && endDate)) {
      console.warn("Both start and end dates are required.");
      return;
    }

    const queryParams = {
      search,
      jobType: jobTypeFilter !== "all" ? jobTypeFilter : undefined,
      refund: statusFilter !== "allStatus" ? statusFilter : undefined,
      dateLowerRange,
      dateUpperRange,
      filter,
      sort,
      page,
      limit: pageSize,
    };
    Object.keys(queryParams).forEach(
      (key) => queryParams[key] === undefined && delete queryParams[key]
    );

    showSpinner();
    try {
      const resJson = await getretrieveRefundIssueResolutions(queryParams);
      closeSpinner();
      setTotalPages(Math.ceil(resJson?.totalRecords / pageSize));
      setIssueResolutions(resJson?.data || []);
      setCount(resJson);
      if (resJson?.filterCounts) {
        setFilterCount(resJson.filterCounts);
      }
    } catch (error) {
      closeSpinner();
      if (error.response?.status === 401) {
        toast.error(sessionExpired);
        toScreen(false, navigate, "/logout");
      } else {
        toast.error("Error fetching refund resolutions: " + error?.message);
      }
    }
  };

  const getDriverPenaltiesIssueResolutions = async () => {
    const dateLowerRange = formatDateForAPI(cancelledStartDate);
    const dateUpperRange = formatDateForAPI(cancelledEndDate);
    const scheduledDateLowerRange = formatDateForAPI(scheduledStartDate);
    const scheduledDateUpperRange = formatDateForAPI(scheduledEndDate);

    if (
      (cancelledStartDate && !cancelledEndDate) ||
      (!cancelledStartDate && cancelledEndDate)
    ) {
      console.warn("Both cancelled start and end dates are required.");
      return;
    }

    if (
      (scheduledStartDate && !scheduledEndDate) ||
      (!scheduledStartDate && scheduledEndDate)
    ) {
      console.warn("Both scheduled start and end dates are required.");
      return;
    }

    const queryParams = {
      search,
      jobType: jobTypeFilter !== "all" ? jobTypeFilter : undefined,
      penalty: statusFilter !== "allStatus" ? statusFilter : undefined,
      dateLowerRange,
      dateUpperRange,
      scheduledDateLowerRange,
      scheduledDateUpperRange,
      filter,
      sort,
      page,
      limit: pageSize,
    };

    Object.keys(queryParams).forEach(
      (key) => queryParams[key] === undefined && delete queryParams[key]
    );

    showSpinner();
    try {
      const resJson = await getretrieveDriverPenaltiesIssueResolutions(queryParams);
      closeSpinner();
      setTotalPages(Math.ceil(resJson?.totalRecords / pageSize));
      setIssueResolutions(resJson?.data || []);
      setCount(resJson);
      if (resJson?.filterCounts) {
        setFilterCount(resJson.filterCounts);
      }
    } catch (error) {
      closeSpinner();
      if (error.response?.status === 401) {
        toast.error(sessionExpired);
        toScreen(false, navigate, "/logout");
      } else {
        toast.error("Error fetching driver penalties: " + error?.message);
      }
    }
  };

  const getDriverPayIssueResolutions = async () => {
    const dateLowerRange = formatDateForAPI(cancelledStartDate);
    const dateUpperRange = formatDateForAPI(cancelledEndDate);

    if (
      (cancelledStartDate && !cancelledEndDate) ||
      (!cancelledStartDate && cancelledEndDate)
    ) {
      console.warn("Both cancelled start and end dates are required.");
      return;
    }

    if (
      (scheduledStartDate && !scheduledEndDate) ||
      (!scheduledStartDate && scheduledEndDate)
    ) {
      console.warn("Both scheduled start and end dates are required.");
      return;
    }

    const queryParams = {
      search,
      jobType: jobTypeFilter !== "all" ? jobTypeFilter : undefined,
      eligibility: eligibilityFilter !== "all" ? eligibilityFilter : undefined,
      dateLowerRange,
      dateUpperRange,
      filter,
      sort,
      page,
      limit: pageSize,
    };

    Object.keys(queryParams).forEach(
      (key) => queryParams[key] === undefined && delete queryParams[key]
    );

    showSpinner();
    try {
      const resJson = await getretrieveDriverPayIssueResolutions(queryParams);
      closeSpinner();
      setTotalPages(Math.ceil(resJson?.totalRecords / pageSize));
      setIssueResolutions(resJson?.data || []);
      setCount(resJson);
      if (resJson) {
        setFilterCount(resJson);
      }
    } catch (error) {
      closeSpinner();
      if (error.response?.status === 401) {
        toast.error(sessionExpired);
        toScreen(false, navigate, "/logout");
      } else {
        toast.error("Error fetching driver pay eligibility: " + error?.message);
      }
    }
  };

  // Fetch data when filters change
  useEffect(() => {
    if (activeTab === "refund") {
      getRefundIssueResolutions();
    } else if (activeTab === "driverPenalties") {
      getDriverPenaltiesIssueResolutions();
    } else if (activeTab === "driverPayEligibility") {
      getDriverPayIssueResolutions();
    }
  }, [
    activeTab,
    search,
    jobTypeFilter,
    statusFilter,
    eligibilityFilter,
    startDate,
    endDate,
    cancelledStartDate,
    cancelledEndDate,
    scheduledStartDate,
    scheduledEndDate,
    sort,
    page,
    pageSize,
  ]);

  // Reset tab-specific filters when switching tabs
  useEffect(() => {
    setSearchValue("");
    setSearch("");
    setJobTypeFilter("all");
    setStatusFilter("allStatus");
    setEligibilityFilter("all");
    setStartDate(null);
    setEndDate(null);
    setCancelledStartDate(null);
    setCancelledEndDate(null);
    setScheduledStartDate(null);
    setScheduledEndDate(null);
    setPage(1);
    setSort("statusSorter=-1");
  }, [activeTab]);



  const RefundDetailsProps = (anchor) => (
    <Box
      className="issues-drawer-content"
      role="presentation"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <RefundDetails
        view={currentView}
        issueResolution={selectedIssueResolution}
        onClose={toggleDrawer(anchor, false)}
        selectedIssueResolution={selectedIssueResolution}
        userDetails={userDetails}
        conversationDetails={conversationDetails}
        theCallBackFunc={getRefundIssueResolutions}
        getConversations={getConversations}
      />
    </Box>
  );

  const DriverPenaltiesProps = (anchor) => (
    <Box
      className="drawer-content-box"
      role="presentation"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <DriverPenalty
        view={currentView}
        issueResolution={selectedIssueResolution}
        onClose={toggleDrawer(anchor, false)}
        selectedIssueResolution={selectedIssueResolution}
        userDetails={userDetails}
        theCallBackFunc={getDriverPenaltiesIssueResolutions}
        conversationDetails={conversationDetails}
        getConversations={getConversations}
      />
    </Box>
  );

  const DriverPayEligibiltyProps = (anchor) => (
    <Box
      className="drawer-content-box"
      role="presentation"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <DriverPayEligibility
        view={currentView}
        issueResolution={selectedIssueResolution}
        onClose={toggleDrawer(anchor, false)}
        selectedIssueResolution={selectedIssueResolution}
        userDetails={userDetails}
        theCallBackFunc={getDriverPayIssueResolutions}
        conversationDetails={conversationDetails}
        getConversations={getConversations}
      />
    </Box>
  );

  // Reset filters function
  const handleReset = () => {
    setPage(1);
    setSort("statusSorter=-1");
    setSearchValue("");
    setSearch("");
    setJobTypeFilter("all");
    setStatusFilter("allStatus");
    setEligibilityFilter("all");
    setFlaggedByAIStatusFilter("allStatus");
    setFlaggeByAISubmittedStartDate(null);
    setFlaggeByAISubmittedEndDate(null);
    setStartDate(null);
    setEndDate(null);
    setCancelledStartDate(null);
    setCancelledEndDate(null);
    setScheduledStartDate(null);
    setScheduledEndDate(null);
    setFlaggedImagesStartDate(null);
    setFlaggedImagesEndDate(null);
    setActiveFilters({
      refund: null,
      driverPenalties: null,
    });
  };

  const handleBlockImage = (imageId) => {
    showSpinner();
    setTimeout(() => {
      closeSpinner();
      toast.success("Image blocked successfully");
      // Reload flagged images data
      // getFlaggedImages();
    }, 1000);
  };

  const handleAllowImage = (imageId) => {
    showSpinner();
    setTimeout(() => {
      closeSpinner();
      toast.success("Image allowed successfully");
      // Reload flagged images data
      // getFlaggedImages();
    }, 1000);
  };


  const totalRefundCount =
    (count?.jobType?.housemove || 0) +
    (count?.jobType?.senditems || 0) +
    (count?.jobType?.dispose || 0);

  const jobTypeOptions = [
    {
      value: "all",
      label: `All (${totalRefundCount || 0})`,
    },
    {
      value: "housemove",
      label: `House Move (${count?.jobType?.housemove || 0})`,
    },
    {
      value: "senditems",
      label: `Send Items (${count?.jobType?.senditems || 0})`,
    },
    {
      value: "dispose",
      label: `Waste Disposal (${count?.jobType?.dispose || 0})`,
    },
  ];

  const selectedJobTypeOption = jobTypeOptions.find(
    (option) => option.value === jobTypeFilter
  );

  const totalRefundStatusCount =
    (count?.refundCount?.pending || 0) +
    (count?.refundCount?.approved || 0) +
    (count?.refundCount?.rejected || 0);

  const totalPenaltyStatusCount =
    (count?.penaltyStatus?.pending || 0) +
    (count?.penaltyStatus?.["not exempt"] || 0) +
    (count?.penaltyStatus?.exempt || 0);

  const totalDriverPayEligibilityCount =
    (count?.eligibilityStatus?.pending || 0) +
    (count?.eligibilityStatus?.rejected || 0) +
    (count?.eligibilityStatus?.approved || 0);

  const buildStatusOptions = (
    statusCounts = {},
    labels = {},
    allLabel = "All Status"
  ) => {
    const keys = Object.keys(labels);

    const total = keys.reduce((sum, key) => sum + (statusCounts[key] || 0), 0);

    const options = [
      {
        label: `${allLabel} (${total})`,
        value: "allStatus",
      },
      ...keys.map((key) => ({
        label: `${labels[key]} (${statusCounts[key] || 0})`,
        value: key,
      })),
    ];

    return options;
  };
  const statusTypeOptions = buildStatusOptions(
    count?.refundCount,
    {
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
    },
    "All"
  );

  const penaltyStatusOptions = buildStatusOptions(
    count?.penaltyStatus,
    {
      pending: "Pending",
      "not exempt": "Not Exempt",
      exempt: "Waived",
    },
    "All"
  );

  const driverPayEligibilityOptions = buildStatusOptions(
    count?.eligibilityStatus,
    {
      pending: "Pending",
      approved: "Gets Paid",
      rejected: "Not Eligible",
    },
    "All"
  );

  const flaggedByAIStatusOptions = buildStatusOptions(
    count?.flaggedByAIStatus,
    {
      suspended: "Suspended",
      notSuspended: "Not Suspended",
    },
    "All "
  );

  return (
    <>
      <TopNav title="Issues & Resolutions" forwardRoute={"/next"} />
      <div className="global-body">
        <div className="global-body-container">
          <div className="custom-tabs mt-0">
            <div
              className={`tab-item ${activeTab === "refund" ? "active" : ""}`}
              onClick={() => setActiveTab("refund")}
            >
              Refunds
              <span className="badge">{filterCount?.refundsCount || 0}</span>
            </div>
            <div
              className={`tab-item ${
                activeTab === "driverPenalties" ? "active" : ""
              }`}
              onClick={() => setActiveTab("driverPenalties")}
            >
              Driver Penalties
              <span className="badge">
                {filterCount?.driverPenaltiesCount || 0}
              </span>
            </div>
            <div
              className={`tab-item ${
                activeTab === "driverPayEligibility" ? "active" : ""
              }`}
              onClick={() => setActiveTab("driverPayEligibility")}
            >
              Driver Pay Eligibility
              <span className="badge">
                {filterCount?.driverPayEligibilityCount || 0}
              </span>
            </div>
            <div
              className={`tab-item ${
                activeTab === "flaggedByAI" ? "active" : ""
              }`}
              onClick={() => setActiveTab("flaggedByAI")}
            >
              Flagged Messages
              <span className="badge">
                {filterCount?.flaggedByAICount || 0}
              </span>
            </div>
            <div
              className={`tab-item ${
                activeTab === "flaggedImages" ? "active" : ""
              }`}
              onClick={() => setActiveTab("flaggedImages")}
            >
              Flagged Images
              <span className="badge">
                {filterCount?.flaggedImagesCount || 0}
              </span>
            </div>
          </div>

          {activeTab === "refund" && (
            <RefundsTab
              issueResolutions={issueResolutions}
              searchValue={searchValue}
              onSearchChange={(value) => setSearchValue(value)}
              onSearchSubmit={searchIssueAndResolution}
              onReset={handleReset}
              filters={[
                {
                  type: "select",
                  key: "jobType",
                  label: "Job Type",
                  value: jobTypeFilter,
                  onChange: setJobTypeFilter,
                  options: jobTypeOptions,
                },
                {
                  type: "select",
                  key: "refund",
                  label: "Status",
                  value: statusFilter,
                  onChange: setStatusFilter,
                  options: statusTypeOptions,
                },
                {
                  type: "dateRange",
                  key: "requested",
                  label: "Requested",
                  value: { start: startDate, end: endDate },
                  onChange: (dates) => {
                    setStartDate(dates.start);
                    setEndDate(dates.end);
                  },
                },
              ]}
              sort={sort}
              onSort={sortIssueResolutions}
              page={page}
              pageSize={pageSize}
              totalPages={totalPages}
              onPageChange={setPage}
              onPageSizeChange={setPageSize}
              inputValue={inputValue}
              setInputValue={setInputValue}
              state={state}
              toggleDrawer={toggleDrawer}
              RefundDetailsProps={RefundDetailsProps}
              currentView={currentView}
              selectedIssueResolution={selectedIssueResolution}
              userDetails={userDetails}
              filterCount={filterCount}
            />
          )}

          {activeTab === "driverPenalties" && (
            <DriverPenaltiesTab
              issueResolutions={issueResolutions}
              searchValue={searchValue}
              onSearchChange={(value) => setSearchValue(value)}
              onSearchSubmit={searchIssueAndResolution}
              onReset={handleReset}
              filters={[
                {
                  type: "select",
                  key: "penalty",
                  label: "Status",
                  value: statusFilter,
                  onChange: setStatusFilter,
                  options: penaltyStatusOptions,
                },
                {
                  type: "select",
                  key: "jobType",
                  label: "Job Type",
                  value: jobTypeFilter,
                  onChange: setJobTypeFilter,
                  options: jobTypeOptions,
                },
                {
                  type: "dateRange",
                  key: "cancelled",
                  label: "Cancelled",
                  value: { start: cancelledStartDate, end: cancelledEndDate },
                  onChange: (dates) => {
                    setCancelledStartDate(dates.start);
                    setCancelledEndDate(dates.end);
                  },
                },
                {
                  type: "dateRange",
                  key: "scheduled",
                  label: "Scheduled for",
                  value: { start: scheduledStartDate, end: scheduledEndDate },
                  onChange: (dates) => {
                    setScheduledStartDate(dates.start);
                    setScheduledEndDate(dates.end);
                  },
                },
              ]}
              sort={sort}
              onSort={sortIssueResolutions}
              page={page}
              pageSize={pageSize}
              totalPages={totalPages}
              onPageChange={setPage}
              onPageSizeChange={setPageSize}
              inputValue={inputValue}
              setInputValue={setInputValue}
              state={state}
              toggleDrawer={toggleDrawer}
              DriverPenaltiesProps={DriverPenaltiesProps}
            />
          )}

          {activeTab === "driverPayEligibility" && (
            <DriverPayEligibilityTab
              issueResolutions={issueResolutions}
              searchValue={searchValue}
              onSearchChange={(value) => setSearchValue(value)}
              onSearchSubmit={searchIssueAndResolution}
              onReset={handleReset}
              filters={[
                {
                  type: "select",
                  key: "eligibility",
                  label: "Eligibility status",
                  value: statusFilter,
                  onChange: setStatusFilter,
                  options: driverPayEligibilityOptions,
                },
                {
                  type: "select",
                  key: "jobType",
                  label: "Job Type",
                  value: jobTypeFilter,
                  onChange: setJobTypeFilter,
                  options: jobTypeOptions,
                },
                {
                  type: "dateRange",
                  key: "cancelled",
                  label: "Cancelled date",
                  value: { start: cancelledStartDate, end: cancelledEndDate },
                  onChange: (dates) => {
                    setCancelledStartDate(dates.start);
                    setCancelledEndDate(dates.end);
                  },
                },
              ]}
              sort={sort}
              onSort={sortIssueResolutions}
              page={page}
              pageSize={pageSize}
              totalPages={totalPages}
              onPageChange={setPage}
              onPageSizeChange={setPageSize}
              inputValue={inputValue}
              setInputValue={setInputValue}
              state={state}
              toggleDrawer={toggleDrawer}
              DriverPayEligibilityProps={DriverPayEligibiltyProps}
            />
          )}

          {activeTab === "flaggedByAI" && (
            <FlaggedMessagesTab
              issueResolutions={issueResolutions}
              searchValue={searchValue}
              onSearchChange={(value) => setSearchValue(value)}
              onSearchSubmit={searchIssueAndResolution}
              onReset={handleReset}
              filters={[
                {
                  type: "select",
                  key: "flaggedByAIStatus",
                  label: "Status",
                  value: flaggedByAIStatusFilter,
                  onChange: setFlaggedByAIStatusFilter,
                  options: flaggedByAIStatusOptions,
                },
                {
                  type: "dateRange",
                  key: "dateRange",
                  label: "Date Range",
                  value: {
                    start: flaggedByAISubmittedStartDate,
                    end: flaggedByAISubmittedEndDate,
                  },
                  onChange: (dates) => {
                    setFlaggeByAISubmittedStartDate(dates.start);
                    setFlaggeByAISubmittedEndDate(dates.end);
                  },
                },
              ]}
              sort={sort}
              onSort={sortIssueResolutions}
              page={page}
              pageSize={pageSize}
              totalPages={totalPages}
              onPageChange={setPage}
              onPageSizeChange={setPageSize}
              inputValue={inputValue}
              setInputValue={setInputValue}
              navigate={navigate}
              flaggedByAI={flaggedByAI}
            />
          )}

          {activeTab === "flaggedImages" && (
            <FlaggedImages
              flaggedImages={flaggedImages}
              onBlockImage={handleBlockImage}
              onAllowImage={handleAllowImage}
              pageSize={pageSize}
              totalPages={totalPages}
              page={page}
              onPageChange={setPage}
              onPageSizeChange={setPageSize}
              filterCount={filterCount}
            />
          )}
        </div>
      </div>
    </>
  );
};

IssuesResolution.propTypes = {
  userDetails: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
};

export default withNavigate(IssuesResolution);
